import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import './styles.scss';

// Remove setSeeAllRef prop in FTN-174
const Header = ({
    title,
    isFavouriteSport = false,
    titleIconClassName = '',
    link,
    wrapperClass = 'widget-container-header',
    setSeeAllRef = undefined,
}) => {
    const [ t ] = useTranslation();
    const titleTextClass = `${wrapperClass}__text`;
    const titleTextIconClass = classNames({
        [titleIconClassName]: titleIconClassName,
    });
    const extraSpacing = classNames('padding-with-icon', titleTextIconClass);
    const seeAllRef = useRef(null);

    useEffect(() => {
        if(setSeeAllRef) {
            setSeeAllRef(seeAllRef);
        }
    }, []);

    return (
        <h2
            className={`${titleTextClass} ${titleTextIconClass} ${extraSpacing}`}
        >
            <span
                className={`${titleTextClass}__heading ${titleTextClass}__title`}
            >
                {title}
                {
                    isFavouriteSport
                    ? <div className="fav-sports-star" />
                    : null
                }
            </span>
            {
                link
                ? <span className={`${wrapperClass}__see-all`} ref={seeAllRef}>
                    {t('betcard.see_all')}
                </span>
                : null
            }
        </h2>
    );
};

Header.propTypes = {
    title: PropTypes.string.isRequired,
    titleIconClassName: PropTypes.string,
    isFavouriteSport: PropTypes.bool,
    link: PropTypes.string,
    wrapperClass: PropTypes.string,
    setSeeAllRef: PropTypes.func,
};

export default Header;
